module.exports = __webpack_public_path__ + "static/logo-thinktherefore-6c9a3d21637034e1621e9f7508862bc8.png";